import styled from '@emotion/styled';

import { Container } from '@/components/ui/Container';
import { colors, font, mq, spacing } from '@/lib/theme';
import { useI18n } from '@/locales';

const Footer = styled.footer`
	margin-top: auto;
	/* The page content already ends with its own bottom padding. */
	padding: 0 0 ${spacing.space50};
`;

const Row = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${spacing.space30};
	padding-top: ${spacing.space50};
	border-top: 1px solid ${colors.interface.border};
	${font('IR90')}
	color: ${colors.typography.body};

	${mq.md} {
		flex-direction: row;
		justify-content: space-between;
	}

	a {
		color: ${colors.typography.heading};
		text-decoration: underline;
		text-underline-offset: 3px;
		text-decoration-color: ${colors.LM_NU40};

		&:hover {
			color: ${colors.typography.link};
			text-decoration-color: currentColor;
		}
	}
`;

const Links = styled.nav`
	display: flex;
	gap: ${spacing.space50};
`;

export const TERMS_URL =
	'https://help.travelnest.com/travelnest-guest-terms-of-service';
export const PRIVACY_URL =
	'https://help.travelnest.com/travelnest-guest-privacy-policy';

interface PageFooterProps {
	narrow?: boolean;
}

export const PageFooter = ({ narrow }: PageFooterProps) => {
	const t = useI18n();

	return (
		<Footer>
			<Container narrow={narrow}>
				<Row>
					<span>
						{t('PageFooter.poweredBy')}{' '}
						<a
							href="https://travelnest.com/"
							target="_blank"
							rel="noreferrer"
						>
							{t('common.Travelnest')}
						</a>
					</span>
					<Links aria-label="Legal">
						<a href={TERMS_URL} target="_blank" rel="noreferrer">
							{t('PageFooter.termsAndConditions')}
						</a>
						<a href={PRIVACY_URL} target="_blank" rel="noreferrer">
							{t('PageFooter.privacyPolicy')}
						</a>
					</Links>
				</Row>
			</Container>
		</Footer>
	);
};
